















































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  FetchState,
} from "@/shared/types";
import {
  EmployeeContribution
} from "@/employer/types";
import moment from "moment";
import "moment-timezone";
import { Location } from "vue-router";
import _ from "lodash";
import Pagination from "@/shared/components/ui/Pagination.vue";
import EmployeePayrollRowEdit from "@/employer/components/profile/EmployeePayrollRowEdit.vue";
import EmployeePayrollRowView from "@/employer/components/profile/EmployeePayrollRowView.vue";
import Button from "@/shared/components/ui/Button.vue";
import ContributionsNavigation from "@/employer/components/profile/ContributionsNavigation.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useEmployerPayrollStore } from "@/employer/store/employerPayroll";
import { useUserStore } from "@/shared/store/user";
import { useEmployeeStore } from "@/employer/store/employee";

const UnknownErrorMessage = "Error processing your request. Please try again later";
const CstTz = "America/Chicago";

@Component({
  components: {
    EmployeePayrollRowView,
    EmployeePayrollRowEdit,
    Pagination,
    Button,
    ContributionsNavigation
  }
})
export default class ManagePayroll extends Vue {

  employeeContributions: EmployeeContribution[] = [];
  notifierStore = useNotifierStore();
  employerPayrollStore = useEmployerPayrollStore();
  employeeStore = useEmployeeStore();
  userStore = useUserStore();

  @Prop()
  page: number;

  @Prop()
  routeToManagePayroll: (pageNumber: number) => Location;

  lockEpoch: moment.Moment;
  isLocked = false;
  intervalId: number;
  isSubmitting = false;
  searchTerm = "";
  searchResultCount = 0;

  mounted () {
    this.loadEmployeeContributions(true);

    this.lockEpoch = this.cutoffDateLocalMoment;
    this.updateLock();

    if (this.isLocked === false) {
      this.intervalId = window.setInterval(this.updateLock, 1000);
    }
  }

  beforeDestroy () {
    this.clearInterval();
  }

  clearInterval () {
    if (this.intervalId) {
      window.clearInterval(this.intervalId);
      this.intervalId = 0;
    }
  }

  updateLock () {
    if (this.isLocked) {
      return;
    }

    if (moment().isSameOrAfter(this.lockEpoch)) {
      this.isLocked = true;
      this.clearInterval();
    }
  }

  onSearch (): void {
    if (!this.isSubmitting) {
      this.isSubmitting = true;
      this.employerPayrollStore.setPageNumber(1);
      this.switchPage(1);
      this.loadEmployeeContributions(true);
      this.isSubmitting = false;
    }
  }

  clearSearch (): void {
    const searchElementReference = this.$refs.autocompleteSearch as any;
    searchElementReference.inputValue = "";
    if (!this.isSubmitting) {
      this.isSubmitting = true;
      this.searchTerm = "";
      this.employerPayrollStore.setPageNumber(1);
      this.switchPage(1);
      this.loadEmployeeContributions(true);
      this.isSubmitting = false;
    }
  }

  @Watch("searchTerm")
  onSearchTermChange (searchValue): void {
    this.debouncedSearch(searchValue, this.userStore.employerId);
  }

  debouncedSearch = _.debounce((searchTerm, employerId) => this.employeeStore.getEmployeeSearchList({
    employerId,
    searchTerm
  }), 600);

  get payrollDateMoment () { return moment(this.employerPayrollStore.payrollDate); }

  get payrollEditCutOffMoment () { return moment.utc(this.employerPayrollStore.payrollEditCutOffDate); }

  get cutoffDateLocalMoment () { return moment.tz(this.payrollEditCutOffMoment, moment.tz.guess()); }

  get formattedPayrollDate () {
    return this.payrollDateMoment.format("MMM DD, YYYY");
  }

  @Watch("page")
  onRouteValuePageNumberChanged () {
    this.loadEmployeeContributions(false);
  }

  handleError (err) {
    this.notifierStore.setDanger(err.errorMessage || UnknownErrorMessage);
  }

  get formattedCutoffTime () {
    return this.cutoffDateLocalMoment.format("hA");
  }

  get formattedCutoffDate () {
    return moment(this.cutoffDateLocalMoment).format("MMM DD");
  }

  get isLoaded (): boolean {
    return this.employerPayrollStore.getFetchState === FetchState.Loaded;
  }

  switchPage (toPage: number) {
    this.$router.push(this.routeToManagePayroll(toPage));
  }

  loadEmployeeContributions (clearState: boolean) {
    this.employerPayrollStore.setPageNumber(this.page);
    this.employerPayrollStore.getContributionsList(
      this.employerPayrollStore.pageNumber,
      this.employerPayrollStore.pageSize,
      this.searchTerm,
      clearState
    )
      .then(() => {
        this.employeeContributions = this.employerPayrollStore.getContributionsByPageNumber(this.employerPayrollStore.pageNumber);
      })
      .catch(this.handleError);
  }
}
